import template from './ptzControls.html';

/* @ngInject */
function PTZControlsController(growl, PTZControlsService) {
  const vm = this;

  /** local variables */
  let timeoutDurationBackUp = null;

  /** public variables */
  vm.disableSetHomeButton = false;
  vm.disableTimeoutDuration = false;

  /** public functions */
  vm.$onInit = init;
  vm.moveInDirection = moveInDirection;
  vm.setHome = setHome;
  vm.setHomeTimeout = setHomeTimeout;

  function init() {
    PTZControlsService.getIdleTimeout(vm.currentCamera.id)
      .then((timeoutDuration) => {
        vm.timeoutDuration = timeoutDuration;
        timeoutDurationBackUp = timeoutDuration;
      })
      .catch((res) => {
        growl.error(res.error, {
          title: 'Error Getting Current Wait Time:'
        });
      });
  }

  function moveInDirection(direction) {
    PTZControlsService.moveInDirection(vm.currentCamera.id, direction)
      .then(() => {
        if (vm.moveCallback) {
          vm.moveCallback();
        }
      });
  }

  function setHome() {
    let growlMessage = growl.info('Setting current position as new "Home"...', {
      disableCloseButton: true
    });
    vm.disableSetHomeButton = true;
    PTZControlsService.setHome(vm.currentCamera.id)
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('New "Home" set successfully');
        vm.disableSetHomeButton = false;
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error, {
          title: 'Error Setting New Home:'
        });
        vm.disableSetHomeButton = false;
      });
  }

  function setHomeTimeout() {
    vm.disableTimeoutDuration = true;
    let growlMessage = growl.info('Setting Return Home Wait Time...', {
      disableCloseButton: true
    });
    PTZControlsService.setHomeTimeout(vm.currentCamera.id, vm.timeoutDuration)
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('Return Home Wait Time saved successfully');
        timeoutDurationBackUp = vm.timeoutDuration;
        vm.disableTimeoutDuration = false;
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error, {
          title: 'Error Saving Return Home Wait Time:'
        });
        vm.timeoutDuration = timeoutDurationBackUp;
        vm.disableTimeoutDuration = false;
      });
  }
}

export default {
  name: 'ptzControls',
  template,
  controllerAs: 'PTZControlsCtrl',
  controller: PTZControlsController,
  bindings: {
    currentCamera: '<'
  }
};
